'use client';

import AppLayout from '@/components/AppLayout';
import RouteGuard from '@/components/RouteGuard';
import ReportingContent from './components/ReportingContent';

export default function ReportingPage() {
  return (
    <RouteGuard allowedRoles={['Administrateur', 'Broker']} redirectTo="/liste-des-locaux">
      <AppLayout currentPath="/reporting">
        <ReportingContent />
      </AppLayout>
    </RouteGuard>
  );
}
